(function(){
  function onScroll(){
    var y = window.scrollY || document.documentElement.scrollTop;
    document.body.classList.toggle('mv-scrolled', y > 12);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function markSections(){
    var main = document.querySelector('#MainContent');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function(sec, i){
      if (i === 0) return;
      sec.setAttribute('data-mv-fade', '');
    });
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function(sec){ sec.classList.add('mv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('mv-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    sections.forEach(function(sec){ io.observe(sec); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markSections);
  } else {
    markSections();
  }
})();
